// import React from 'react';
// import { 
//   Gavel, Scale, ShieldCheck, Clock, 
//   Handshake, FileCheck, ShieldAlert, Award,
//   CheckCircle, Building2, Globe
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';
// export default function ArbitrationServices() {
  
//   // Advantages of Arbitration over traditional litigation
//   const advantages = [
//     {
//       title: "السرعة والفعالية الزمنية",
//       desc: "تتميز إجراءات التحكيم بالفصل السريع في الخصومات مقارنة بالقضاء التقليدي، والالتزام بمدد زمنية محددة.",
//       icon: <Clock className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "السرية التامة والمطلقة",
//       desc: "تتم كافة جلسات ومداولات وثائق التحكيم في إطار سري تماماً لحماية السمعة التجارية للشركات وبياناتها الحساسة.",
//       icon: <ShieldCheck className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "حرية اختيار المحكمين",
//       desc: "يتيح التحكيم للأطراف اختيار محكمين يمتلكون خبرات فنية وهندسية وتجارية دقيقة تخدم طبيعة النزاع المعقدة.",
//       icon: <Gavel className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   // Specific Areas we handle
//   const arbitrationScopes = [
//     { name: "التحكيم في منازعات المقاولات والإنشاءات", icon: <Building2 className="w-5 h-5" />, desc: "تسوية الخلافات الهندسية، التأخيرات، مطالبات الأوامر التغييرية، وعقود الفيديك (FIDIC)." },
//     { name: "منازعات الشركاء والشركات الاستثمارية", icon: <Handshake className="w-5 h-5" />, desc: "حل خلافات التخارج، تصفية الشركات، ومنازعات اتفاقيات المساهمين والمشاريع المشتركة." },
//     { name: "التحكيم التجاري الدولي والمحلي", icon: <Globe className="w-5 h-5" />, desc: "تمثيل الشركات أمام مراكز التحكيم المحلية والدولية مثل المركز السعودي للتحكيم التجاري (SCCA)." }
//   ];

//   return (
//     <div className="bg-white text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="التحكيم وتسوية المنازعات التجارية"
//         description="نقدم حلولاً قانونية شاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">الحلول البديلة لتسوية المنازعات</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">التحكيم وتسوية المنازعات التجارية</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نوفر لعملائنا مساراً قانونياً مرناً وسريعاً لحسم النزاعات التجارية المعقدة من خلال صياغة اتفاقيات التحكيم، والتمثيل الاحترافي أمام هيئات التحكيم المحلية والدولية كبديل استراتيجي متكامل للقضاء.
//           </p>
//         </div>
//       </section>

//       {/* Intro Framework under Saudi Law */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-snug">
//               التحكيم: قضاء متوازن لحماية الاستقرار التجاري
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               وفقاً لنظام التحكيم السعودي، يحظى حكم التحكيم بحجية الأمر المقضي به ويعد ملزماً وقابلاً للتنفيذ الجبري فور المصادقة عليه. هذا المفهوم يمنح منشآت الأعمال المرونة الكاملة لحل خصوماتها دون تعطيل وتجميد وتيرة عملياتها التشغيلية.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               لا يقتصر دورنا على إدارة الخصومة التحكيمية فحسب، بل نعمل كمحكمين معتمدين للفصل في النزاعات، إلى جانب خبرتنا الطويلة في صياغة (شرط التحكيم) الوقائي باحترافية لتجنب بطلان الإجراءات مستقبلاً.
//             </p>
//           </div>
          
//           <div className="bg-slate-900 text-slate-100 p-8 rounded-2xl border border-slate-800 space-y-6 relative overflow-hidden shadow-xl">
//             <div className="absolute top-0 right-0 bg-amber-500/10 w-32 h-32 rounded-full blur-2xl"></div>
//             <h3 className="text-xl font-bold text-amber-500 flex items-center gap-2 mb-2">
//               <Scale className="w-5 h-5" /> خدماتنا الشاملة في التحكيم
//             </h3>
//             <ul className="space-y-4 text-sm text-slate-300">
//               <li className="flex items-start gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 mt-1 shrink-0" />
//                 <span>تمثيل الخصوم وإعداد مذكرات الدعوى والردود أمام هيئات التحكيم.</span>
//               </li>
//               <li className="flex items-start gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 mt-1 shrink-0" />
//                 <span>العمل كمحكمين مرشحين أو منفردين لرئاسة هيئات التحكيم وإصدار الأحكام.</span>
//               </li>
//               <li className="flex items-start gap-2">
//                 <CheckCircle className="w-4 h-4 text-amber-500 mt-1 shrink-0" />
//                 <span>رفع دعاوى بطلان أحكام التحكيم أو متابعة إجراءات تنفيذها عبر قضاء التنفيذ.</span>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </section>

//       {/* Three Main Advantages Cards */}
//       <section className="bg-slate-50 py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">لماذا يفضل قطاع الأعمال التحكيم؟</h2>
//             <p className="text-gray-500 max-w-xl mx-auto">مزايا جوهرية تجعل التحكيم الأداة المفضلة لدى المستثمرين والشركات الكبرى محلياً وعالمياً</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {advantages.map((adv, index) => (
//               <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
//                 <div className="mb-5 inline-block p-3 bg-amber-50 rounded-lg">
//                   {adv.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-800 mb-3">{adv.title}</h3>
//                 <p className="text-gray-600 text-sm leading-relaxed">{adv.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Core Scopes List */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="text-center mb-16">
//           <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-3">أبرز اختصاصاتنا في القضايا التحكيمية</h2>
//           <p className="text-gray-500">نمتلك السجل المهني اللازم للتعامل مع أضخم النزاعات العقدية</p>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//           {arbitrationScopes.map((scope, index) => (
//             <div key={index} className="bg-white p-6 rounded-xl border-t-4 border-t-amber-600 border-x border-b border-gray-200 shadow-sm flex flex-col justify-between">
//               <div>
//                 <div className="text-amber-600 mb-4 bg-amber-50 w-10 h-10 rounded-full flex items-center justify-center">
//                   {scope.icon}
//                 </div>
//                 <h3 className="text-lg font-bold text-slate-800 mb-2">{scope.name}</h3>
//                 <p className="text-gray-500 text-xs leading-relaxed">{scope.desc}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Legal Disclaimer Box */}
//       <section className="max-w-4xl mx-auto py-12 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <ShieldAlert className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">نصيحة وقائية لشركتك:</h4>
//             <p className="text-amber-900 text-sm leading-relaxed">
//               إغفال صياغة بند التحكيم بدقة (مثل تحديد القانون الواجب التطبيق، مقر التحكيم، لغة التحكيم، وعدد المحكمين) قد يترتب عليه بطلان اتفاق التحكيم بالكامل والاضطرار للعودة إلى المحاكم العادية، وهو ما يفقدك ميزة التحكيم الجوهرية.
//             </p>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// }


import React from 'react';
import { 
  Gavel, Scale, ShieldCheck, Clock, 
  Handshake, FileCheck, ShieldAlert, Award,
  CheckCircle, Building2, Globe
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';

export default function ArbitrationServices() {
  
  // Advantages of Arbitration over traditional litigation - Navy Light Styling
  const advantages = [
    {
      title: "السرعة والفعالية الزمنية",
      desc: "تتميز إجراءات التحكيم بالفصل السريع في الخصومات مقارنة بالقضاء التقليدي، والالتزام بمدد زمنية محددة.",
      icon: <Clock className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "السرية التامة والمطلقة",
      desc: "تتم كافة جلسات ومداولات وثائق التحكيم في إطار سري تماماً لحماية السمعة التجارية للشركات وبياناتها الحساسة.",
      icon: <ShieldCheck className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "حرية اختيار المحكمين",
      desc: "يتيح التحكيم للأطراف اختيار محكمين يمتلكون خبرات فنية وهندسية وتجارية دقيقة تخدم طبيعة النزاع المعقدة.",
      icon: <Gavel className="w-6 h-6 text-indigo-950" />
    }
  ];

  // Specific Areas we handle - Navy Light Styling
  const arbitrationScopes = [
    { name: "التحكيم في منازعات المقاولات والإنشاءات", icon: <Building2 className="w-5 h-5" />, desc: "تسوية الخلافات الهندسية، التأخيرات، مطالبات الأوامر التغييرية، وعقود الفيديك (FIDIC)." },
    { name: "منازعات الشركاء والشركات الاستثمارية", icon: <Handshake className="w-5 h-5" />, desc: "حل خلافات التخارج، تصفية الشركات، ومنازعات اتفاقيات المساهمين والمشاريع المشتركة." },
    { name: "التحكيم التجاري الدولي والمحلي", icon: <Globe className="w-5 h-5" />, desc: "تمثيل الشركات أمام مراكز التحكيم المحلية والدولية مثل المركز السعودي للتحكيم التجاري (SCCA)." }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="التحكيم وتسوية المنازعات التجارية"
        description="نقدم حلولاً قانونية شاملة وبديلة لدعم نمو واستقرار قطاعات الأعمال في السوق السعودي"
      />
      
      {/* Hero Header Section - Converted to Light Premium */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for luxurious light feeling */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">الحلول البديلة لتسوية المنازعات</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">التحكيم وتسوية المنازعات التجارية</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نوفر لعملائنا مساراً قانونياً مرناً وسريعاً لحسم النزاعات التجارية المعقدة من خلال صياغة اتفاقيات التحكيم، والتمثيل الاحترافي أمام هيئات التحكيم المحلية والدولية كبديل استراتيجي متكامل للقضاء.
          </p>
        </div>
      </section>

      {/* Intro Framework under Saudi Law */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-snug">
              التحكيم: قضاء متوازن لحماية الاستقرار التجاري
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              وفقاً لنظام التحكيم السعودي، يحظى حكم التحكيم بحجية الأمر المقضي به ويعد ملزماً وقابلاً للتنفيذ الجبري فور المصادقة عليه. هذا المفهوم يمنح منشآت الأعمال المرونة الكاملة لحل خصوماتها دون تعطيل وتجميد وتيرة عملياتها التشغيلية.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              لا يقتصر دورنا على إدارة الخصومة التحكيمية فحسب، بل نعمل كمحكمين معتمدين للفصل في النزاعات، إلى جانب خبرتنا الطويلة في صياغة (شرط التحكيم) الوقائي باحترافية لتجنب بطلان الإجراءات مستقبلاً.
            </p>
          </div>
          
          {/* Side Card converted to Light Premium Layout */}
          <div className="bg-slate-50 text-indigo-950 p-8 rounded-2xl border border-slate-200/60 space-y-6 relative overflow-hidden shadow-sm">
            <div className="absolute top-0 right-0 bg-indigo-950/[0.02] w-32 h-32 rounded-full blur-2xl"></div>
            <h3 className="text-xl font-bold text-indigo-950 flex items-center gap-2 mb-2">
              <Scale className="w-5 h-5 text-blue-700" /> خدماتنا الشاملة في التحكيم
            </h3>
            <ul className="space-y-4 text-sm text-slate-700 font-medium">
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-indigo-950 mt-1 shrink-0" />
                <span>تمثيل الخصوم وإعداد مذكرات الدعوى والردود أمام هيئات التحكيم.</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-indigo-950 mt-1 shrink-0" />
                <span>العمل كمحكمين مرشحين أو منفردين لرئاسة هيئات التحكيم وإصدار الأحكام.</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle className="w-4 h-4 text-indigo-950 mt-1 shrink-0" />
                <span>رفع دعاوى بطلان أحكام التحكيم أو متابعة إجراءات تنفيذها عبر قضاء التنفيذ.</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Three Main Advantages Cards */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">لماذا يفضل قطاع الأعمال التحكيم؟</h2>
            <p className="text-slate-500 max-w-xl mx-auto text-sm md:text-base font-light">مزايا جوهرية تجعل التحكيم الأداة المفضلة لدى المستثمرين والشركات الكبرى محلياً وعالمياً</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {advantages.map((adv, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-all duration-300">
                <div className="mb-5 inline-block p-3 bg-slate-50 rounded-lg">
                  {adv.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-3">{adv.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{adv.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Scopes List */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">أبرز اختصاصاتنا في القضايا التحكيمية</h2>
          <p className="text-slate-500 text-sm md:text-base font-light">نمتلك السجل المهني والخبرة اللازمة للتعامل مع أضخم النزاعات العقدية</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {arbitrationScopes.map((scope, index) => (
            <div key={index} className="bg-white p-6 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm flex flex-col justify-between hover:shadow-md transition-shadow duration-300">
              <div>
                <div className="text-indigo-950 mb-4 bg-slate-50 w-10 h-10 rounded-full flex items-center justify-center">
                  {scope.icon}
                </div>
                <h3 className="text-lg font-bold text-indigo-950 mb-2">{scope.name}</h3>
                <p className="text-slate-500 text-xs leading-relaxed font-light">{scope.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Legal Disclaimer Box - Refactored to Executive Slate Tone */}
      <section className="max-w-4xl mx-auto py-12 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <ShieldAlert className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1 flex items-center gap-2">نصيحة وقائية لشركتك:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              إغفال صياغة بند التحكيم بدقة (مثل تحديد القانون الواجب التطبيق، مقر التحكيم، لغة التحكيم، وعدد المحكمين) قد يترتب عليه بطلان اتفاق التحكيم بالكامل والاضطرار للعودة إلى المحاكم العادية، وهو ما يفقدك ميزة التحكيم الجوهرية.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}